import {make} from 'vuex-pathify'
import json from '../../../static/hobbies.json'

const state = {
    loaded: false,
    associations: [],
    sports: [],
    travels: [],
    readings: []
}

const mutations = {
    ...make.mutations(state)
}

const actions = {
    ...make.actions(state),
    loadHobbies ({commit}) {
        commit('SET_ASSOCIATIONS', json.associations)
        commit('SET_SPORTS', json.sports)
        commit('SET_TRAVELS', json.travels)
        commit('SET_READINGS', json.readings)
        commit('SET_LOADED', true)
    }
}

const getters = {
    ...make.getters(state),
    isLoaded () {
        return state.loaded
    },
    getAssociations () {
        return state.associations
    },
    getSports () {
        return state.sports
    },
    getTravels () {
        return state.travels
    },
    getReadings () {
        return state.readings
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/hobbiesModule.js